import { Message, MessageAddress, MessageAddressReceiverResponse } from '@/api'

/**
 * メッセージから送信者情報をメッセージアドレス形式で取得する
 * @param message
 * @returns
 */
export const getSenderFromMessage = (message: Message): MessageAddress => {
  return {
    department: message.department,
    department_code: message.department_code,
    department_name: message.department_name,
    section: message.section,
    section_code: message.section_code,
    section_name: message.section_name,
    user: message.user,
    user_name: message.user_name,
    is_applicant: message.is_applicant,
    email: message.email,
  }
}

/**
 * 申請者のメールアドレスがnullかどうかをチェック
 * 代理申請の際は申請者メールアドレスがnullの可能性があるためそのチェック
 */
export const isEmptyApplicantMailAddress = (messageAddress: MessageAddressReceiverResponse[]): boolean => {
  const applicantAddress = messageAddress.find((ma) => ma.is_applicant)
  if (applicantAddress == null) {
    // 申請者が含まれない場合はfalse
    return false
  } else {
    // 申請者が含まれており、メールアドレスが未設定の場合はtrueを返す
    return applicantAddress.email == null
  }
}

/**
 * 送受信者の表示名を返す
 * @param isApplicant
 * @param departmentName
 * @param userName
 * @returns
 */
export const displaySenderOrRecipientName = ({
  isApplicant,
  departmentName = null,
  userName = null,
  isApplicantHistory = false,
  departmentMailName = null,
}: {
  isApplicant: boolean
  departmentName?: string | null
  userName?: string | null
  isApplicantHistory?: boolean
  departmentMailName?: string | null
}): string => {
  if (isApplicantHistory) {
    if (isApplicant) {
      return '申請者様'
    } else {
      return departmentMailName ?? ''
    }
  } else {
    if (isApplicant) {
      return '協議先'
    } else {
      const displays: string[] = []
      if (departmentName != null) {
        displays.push(departmentName)
      }
      if (userName != null) {
        displays.push(userName)
      }
      // 半角スペースで繋げて返す
      return displays.join(' ')
    }
  }
}
